import styled, { css } from "styled-components";
import { shade } from 'polished';
import { colors } from "../../../../../theme/theme";

interface ButtonProps {
    color: string;
}

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: left;
    /* max-width: 280px; */
    box-shadow: 0px 2px 8px rgba(51, 51, 51, 0.15);
    border-radius: 4px;
    padding: 20px;

    @media only screen and (max-width: 780px) { 
       align-items: center !important;
    }


    span { 
        color: ${colors.greyscale.darker_grey};
        font-size: 18px;
        
    }

    h5 { 
        font-size: 32px;
        font-weight: 700;
        /* margin-left: 10px; */
        margin-bottom: 0px;
    }

    svg { 
            margin-right: 20px ;
    }

    img { 
        margin-right: 20px ;
    }

    main { 
        display: flex;
        justify-content: space-between;
        align-items: center;
        
    }

`;

export const ToggleBtn = styled.button<ButtonProps>`
        display: flex;
        align-items: center;
        background-color: transparent;
        border: 0px;
        padding: 0px;

        svg { 
            margin-right: 0px;
            ${props =>
            props.color &&
            css`
                color: ${props.color};
             ` }
        }

        &:hover {

                svg { 
                    ${props =>
        props.color &&
        css`
                    color: ${shade(0.2, props.color)};
                     ` }
                }

            
        }
`;